export default {
	1: 'Something went wrong. Please, try again later',
	2: 'Lock server at stock is not available',

	1000: 'Email is required',
	1001: 'Invalid E-Mail',
	1002: 'Password is required',
	1003: 'Field is required',
	1004: 'Not allowed symbols number',
	1005: 'Wrong format',

	1077: 'No current invoices found',

	5000: 'User has active contracts. Please, check them',

	6001: 'Box is already booked',
	6002: 'Unknown user',
	6003: 'Box or Stock must be provided',
	6004: 'User is not found',
	6005: 'Box is not found',
	6006: 'Stock is not found',
	6007: 'This box is placed not in this stock',
	6008: 'Client IP is required',
	6009: 'You need to connect to the warehouse Wi-Fi network to open the door',
	6010: 'Sorry, there is no available boxes with specified params',
	6011: 'Lock number is already used',
	6013: 'Bad lock id configuration',
	6014: 'You have not agreed with contract offer and it\'s applications.',

	7000: 'No actual payment',
	7001: 'Your profile is not verified. You cant perform this action',
	7002: 'You can not open the warehouse during non-working hours',
	7003: 'the start date of the contract has not yet arrived',
	7005: 'Contract is not started',
	7008: 'Contract expired',

	9000: 'User with such email already exists.',
	9001: 'Invalid data provided.',
	9003: 'Log In, please',

	unrecognized: 'Something went wrong. Please, try again later',
	error: 'Error',
};
